import { BqsService } from './Service/bqs.service';
import { ConfigService } from './Service/config.service';
import { SessionService } from './Service/session.service';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from './Common/translate-http-loader';

import { AppRoutingModule } from './app.routing';
import { AppComponent } from './app.component';
import { SignupComponent } from './Signup/signup.component';
import { SuccessComponent } from './Success/success.component';
import { FailedComponent } from './Failed/failed.component';

/**
 * Main module for the application
 * 
 * @export
 * @class AppModule
 */
@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: Http) =>
          new TranslateHttpLoader(http, 'api/resources/list/', [
            'pharmacy',
            'notification'
          ]),
        deps: [Http]
      }
    })
  ],
  exports: [BrowserModule],
  declarations: [
    AppComponent,
    SignupComponent,
    FailedComponent,
    SuccessComponent
  ],
  providers: [BqsService, ConfigService, SessionService],
  bootstrap: [AppComponent]
})
export class AppModule {}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.module.ts
 **/